import { gsap } from 'gsap';

const handleHero = () => {
  const breakpoint = 768;

  const bannerContainerSelector = '.banner-container';
  const h1Selector = '.h1';
  const topBarSelector = '.top-bar';
  const headerUnderlineSelector = '.header-underline';

  const bannerContainerEl = document?.querySelector(bannerContainerSelector);
  const h1El = document?.querySelector(h1Selector);
  const topBarEl = document?.querySelector(topBarSelector);
  const headerUnderlineEl = document?.querySelector(headerUnderlineSelector);

  if (window.innerWidth >= breakpoint) {
    const twContainerSelector = '.hero-container';
    const btnSelector = '.hero-btn';
    const videoSelector = '.hero-video';

    const iconSelector = '.hero-btn__icon';

    const twContainerEl = document.querySelector(twContainerSelector);
    const btnEl = document.querySelector(btnSelector);
    const videoEl = document.querySelector(videoSelector);
    const iconEl = btnEl?.querySelector(iconSelector);

    const foundAllEl =
      twContainerEl !== null &&
      bannerContainerEl !== null &&
      videoEl !== null &&
      btnEl !== null;

    if (foundAllEl) {
      if (window.innerWidth >= 768 && window.innerWidth < 1536) {
        const { y } = bannerContainerEl.getBoundingClientRect();

        const freeSpace = window.innerHeight - y;

        if (freeSpace <= 450) {
          bannerContainerEl.classList.add('visible-overflow');
          const arrowContainer = document.querySelector(
            '.hero-btn-arrow-container'
          );

          if (arrowContainer !== null) {
            arrowContainer.classList.add('sticky-element');
            arrowContainer.style.height = 'fit-content';
          }
          btnEl.style.alignItems = 'normal';
          bannerContainerEl.style.maxHeight = `${450}px`;
        } else if (freeSpace <= 600) {
          bannerContainerEl.style.maxHeight = `${freeSpace}px`;
        }
      }

      const animateEntrance = () => {
        let { left: containerLeft } = twContainerEl.getBoundingClientRect();
        const containerPaddingLeft = window
          .getComputedStyle(twContainerEl, null)
          .getPropertyValue('padding-left');
        const containerPaddingLeftParsed = parseInt(containerPaddingLeft, 10);
        if (!isNaN(containerPaddingLeftParsed)) {
          containerLeft = containerLeft + containerPaddingLeftParsed;
        }

        const tl = gsap.timeline({
          defaults: { ease: 'power4.inOut', duration: 1.4 },
        });
        tl.addLabel('start', 0)
          .fromTo(
            h1El,
            {
              opacity: 0,
              y: 100,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.55,
              ease: 'power1.out',
            }
          )
          .from(bannerContainerEl, { y: 200 }, '<-=0.15')
          .to(bannerContainerEl, { opacity: 1 }, '<+=0.15')
          .fromTo(
            topBarEl,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: 'sine.in', duration: 0.3 },
            '<+=0.4'
          )
          .fromTo(
            btnEl,
            { width: '100%' },
            { width: `${containerLeft}px` },
            '>-=0.1'
          )
          .fromTo(
            videoEl,
            { autoAlpha: 0, left: `${containerLeft}px` },
            { autoAlpha: 1 },
            '<'
          )
          .from(iconEl, { y: -50, autoAlpha: 0, duration: 1.2 }, '>-=0.8')
          .from(headerUnderlineEl, { scaleX: 0, duration: 0.8 }, '<');
      };

      const setPositions = () => {
        let { left: containerLeft } = twContainerEl.getBoundingClientRect();
        const containerPaddingLeft = window
          .getComputedStyle(twContainerEl, null)
          .getPropertyValue('padding-left');
        const containerPaddingLeftParsed = parseInt(containerPaddingLeft, 10);

        if (!isNaN(containerPaddingLeftParsed)) {
          containerLeft = containerLeft + containerPaddingLeftParsed;
        }

        videoEl.style.left = `${containerLeft}px`;
        btnEl.style.width = `${containerLeft}px`;
      };

      btnEl.addEventListener('click', (e) => {
        const target = e.target;
        const { y, height } = target.getBoundingClientRect();
        const scroll = window.scrollY;

        const headerHeight =
          document.querySelector('header')?.clientHeight ?? 0;

        window.scroll(0, `${scroll + y + height - headerHeight}`);
      });

      animateEntrance();

      window.addEventListener('resize', setPositions);
    } else if (topBarEl !== null) {
      const tl = gsap.timeline({
        defaults: { ease: 'power4.inOut', duration: 1 },
      });

      tl.to(topBarEl, { opacity: 1, ease: 'sine.in', duration: 0.3 }).from(
        headerUnderlineEl,
        { scaleX: 0, duration: 0.8 },
        '<'
      );
    }
  } else {
    const foundAllEl =
      topBarEl !== null &&
      bannerContainerEl !== null &&
      headerUnderlineEl !== null;

    if (foundAllEl) {
      const tl = gsap.timeline({
        defaults: { ease: 'power4.inOut', duration: 1 },
      });

      tl.addLabel('start', 1)
        .fromTo(
          h1El,
          {
            opacity: 0,
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: 'power1.out',
          },
          1
        )
        .from(bannerContainerEl, { y: 30 }, '<-=0.15')
        .to(bannerContainerEl, { opacity: 1 }, '<+=0.15')
        .fromTo('.first-content', { y: 30 }, { autoAlpha: 1, y: 0 }, '<+=0.15')
        .to(topBarEl, { opacity: 1, ease: 'sine.in', duration: 0.3 }, '<+=0.4')
        .from(headerUnderlineEl, { scaleX: 0, duration: 0.8 }, '<');
    } else if (topBarEl !== null && headerUnderlineEl !== null) {
      const tl = gsap.timeline({
        defaults: { ease: 'power4.inOut', duration: 1 },
      });

      tl.to(topBarEl, { opacity: 1, ease: 'sine.in', duration: 0.3 }).from(
        headerUnderlineEl,
        { scaleX: 0, duration: 0.8 },
        '<'
      );
    }
  }
};

export default handleHero;
